function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = ['mainBtn'];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
  useRef,
} from 'react';
import { Button, Icon, Modal, Space } from 'udesk-ui';
import { usePrefixCls } from '../utils';
import CommonFilter from '../common-filter';
import MemoTable from '../memo-table';
import screenfull from 'screenfull';
import TreeMenu from '../tree-menu';
import classNames from 'classnames';
import ColumnsControl from './components/columns-control-btn';
import ExportButton from '../export-button';
import {
  ClassificationWrap,
  FilterWrap,
  Layout,
  RowSelectionInfo,
  TableWrap,
  Toolbar,
} from './components/ui-components';
import { ArrowDownSOutlined, ImportOutlined } from '@udesk/icons';
import BatchedActions from '../batched-actions';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
// import './style/index';
var StandardizeTable = /*#__PURE__*/ forwardRef(function (props, ref) {
  var customizePrefixCls = props.prefixCls,
    className = props.className;
  var table = props.table,
    filter = props.filter,
    classificationWithTitle = props.classification,
    toolBarRightButtons = props.toolBarRightButtons,
    columnsControl = props.columnsControl,
    exportProps = props.exportBtn,
    rowSelectionCount = props.rowSelectionCount,
    importBtn = props.importBtn,
    batchedActions = props.batchedActions,
    showFullscreen = props.showFullscreen;
  var classificationTitle =
    classificationWithTitle === null || classificationWithTitle === void 0
      ? void 0
      : classificationWithTitle.title;
  var _useLocaleReceiver = useLocaleReceiver('StandardizeTable'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    contextLocale = _useLocaleReceiver2[0];
  var pageInstance = useRef(null);
  var tableInstance = useRef(null);
  var filterInstance = useRef(null);
  var _useState = useState(screenfull.isFullscreen),
    _useState2 = _slicedToArray(_useState, 2),
    isFullscreen = _useState2[0],
    setIsFullscreen = _useState2[1];
  useImperativeHandle(ref, function () {
    return {
      pageInstance: pageInstance.current,
      tableInstance: tableInstance.current,
      filterInstance: filterInstance.current,
    };
  });
  var _usePrefixCls = usePrefixCls('standardize-table', customizePrefixCls),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 2),
    standardizeTableCls = _usePrefixCls2[0],
    prefixCls = _usePrefixCls2[1];
  var classes = useMemo(
    function () {
      return classNames(standardizeTableCls, className);
    },
    [standardizeTableCls, className],
  );
  var tablePagination = useMemo(
    function () {
      var _table$pagination;
      return _objectSpread(
        {
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: function showTotal(total, range) {
            return ''
              .concat(contextLocale.lang.num, ' ')
              .concat(range[0], '-')
              .concat(range[1], ' ')
              .concat(contextLocale.lang.total, ' ')
              .concat(total, ' ')
              .concat(contextLocale.lang.strip);
          },
        },
        (_table$pagination = table === null || table === void 0 ? void 0 : table.pagination) !==
          null && _table$pagination !== void 0
          ? _table$pagination
          : {},
      );
    },
    [table === null || table === void 0 ? void 0 : table.pagination],
  );
  var buttonsCount = useMemo(
    function () {
      var _toolBarRightButtons$;
      var buttonsCount = 0;
      // if (rowSelectionCount) buttonsCount++;
      if (exportProps) buttonsCount++;
      if (columnsControl) buttonsCount++;
      if (importBtn) buttonsCount++;
      if (toolBarRightButtons) buttonsCount++;
      if (batchedActions) buttonsCount++;
      if (buttonsCount > 5 && process.env.NODE_ENV === 'development') {
        throw new Error(
          'UI\u89C4\u8303\u89C4\u5B9A\uFF0C\u5DE5\u5177\u680F\u96641\u4E2A\u4E3B\u6309\u94AE\u5916\uFF0C\u6700\u591A\u53EA\u80FD\u540C\u4E8B\u5B58\u57285\u4E2A\u526F\u6309\u94AE\uFF0C\u5F53\u524D\u5B58\u5728'.concat(
            buttonsCount,
            '\u4E2A\u526F\u6309\u94AE\uFF0C\u8BF7\u4E0E\u4EA7\u54C1\u6C9F\u901A\u4FDD\u7559\u54EA\u4E9B',
          ),
        );
      }
      var mainBtnCount =
        (_toolBarRightButtons$ =
          toolBarRightButtons === null || toolBarRightButtons === void 0
            ? void 0
            : toolBarRightButtons.filter(function (i) {
                return i.mainBtn;
              }).length) !== null && _toolBarRightButtons$ !== void 0
          ? _toolBarRightButtons$
          : 0;
      if (mainBtnCount > 1 && process.env.NODE_ENV === 'development') {
        throw new Error(
          'UI\u89C4\u8303\u89C4\u5B9A\uFF0C\u5DE5\u5177\u680F\u81F3\u591A\u53EA\u80FD\u5B58\u57281\u4E2A\u4E3B\u6309\u94AE\uFF0C\u5F53\u524D\u5B58\u5728'.concat(
            mainBtnCount,
            '\u4E2A\u4E3B\u6309\u94AE\uFF0C\u8BF7\u4E0E\u4EA7\u54C1\u6C9F\u901A\u4FDD\u7559\u54EA\u4E2A',
          ),
        );
      }
      return buttonsCount;
    },
    [
      // rowSelectionCount,
      toolBarRightButtons,
      exportProps,
      columnsControl,
      importBtn,
      batchedActions,
    ],
  );
  var toolBarRightButtonsFormatted = useMemo(
    function () {
      if (!toolBarRightButtons) return null;
      var mainBtn = toolBarRightButtons.find(function (i) {
        return i.mainBtn;
      });
      if (mainBtn) {
        mainBtn.type = 'primary';
      }
      var others = toolBarRightButtons.filter(function (i) {
        return !i.mainBtn;
      });
      var subButtonsCount = buttonsCount - 1 + others.length;
      var displaySubButtons = others.slice(0, 5 - buttonsCount + 1);
      var hiddenSubButtons = others.slice(5 - buttonsCount + 1);
      if (hiddenSubButtons.length && displaySubButtons.length) {
        var buttonNeedHidden = displaySubButtons.pop();
        hiddenSubButtons.unshift(buttonNeedHidden);
      }
      var _ref = mainBtn || {},
        _ = _ref.mainBtn,
        mainBtnProps = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/ React.createElement(
        React.Fragment,
        null,
        displaySubButtons.map(function (item) {
          return /*#__PURE__*/ React.createElement(
            Button,
            _objectSpread(
              _objectSpread({}, item),
              {},
              {
                onClick: item.confirm
                  ? function () {
                      Modal.confirm(
                        _objectSpread(
                          _objectSpread({}, item.confirm || {}),
                          {},
                          {
                            onOk: item.onClick,
                            getContainer: function getContainer(triggerNode) {
                              return pageInstance.current || document.body;
                            },
                          },
                        ),
                      );
                    }
                  : item.onClick,
              },
            ),
            item === null || item === void 0 ? void 0 : item.label,
          );
        }),
        Boolean(hiddenSubButtons.length) &&
          /*#__PURE__*/ React.createElement(
            BatchedActions,
            {
              menu: hiddenSubButtons,
              getPopupContainer: function getPopupContainer(triggerNode) {
                return pageInstance.current || document.body;
              },
            },
            /*#__PURE__*/ React.createElement(
              Button,
              null,
              contextLocale.lang.more,
              /*#__PURE__*/ React.createElement(ArrowDownSOutlined, {
                style: {
                  marginLeft: 4,
                },
              }),
            ),
          ),
        mainBtn &&
          /*#__PURE__*/ React.createElement(
            Button,
            _objectSpread({}, mainBtnProps),
            mainBtn === null || mainBtn === void 0 ? void 0 : mainBtn.label,
          ),
      );
    },
    [toolBarRightButtons, buttonsCount],
  );
  useEffect(function () {
    var callback = function callback() {
      setIsFullscreen(screenfull.isFullscreen);
    };
    screenfull.on('change', callback);
    return function () {
      screenfull.off('change', callback);
    };
  }, []);
  var closeFilter = function closeFilter() {
    var _filterInstance$curre, _filterInstance$curre2;
    (_filterInstance$curre = filterInstance.current) === null || _filterInstance$curre === void 0
      ? void 0
      : (_filterInstance$curre2 = _filterInstance$curre.closeFilter) === null ||
        _filterInstance$curre2 === void 0
      ? void 0
      : _filterInstance$curre2.call(_filterInstance$curre);
  };
  return /*#__PURE__*/ React.createElement(
    Layout,
    {
      ref: pageInstance,
      className: classes,
    },
    filter &&
      /*#__PURE__*/ React.createElement(
        FilterWrap,
        null,
        /*#__PURE__*/ React.createElement(
          CommonFilter,
          _objectSpread(
            _objectSpread({}, filter),
            {},
            {
              ref: filterInstance,
            },
          ),
        ),
      ),
    /*#__PURE__*/ React.createElement(
      TableWrap,
      {
        prefixCls: prefixCls,
        padding: classificationWithTitle ? '16px 16px 16px 0' : 16,
      },
      classificationWithTitle &&
        /*#__PURE__*/ React.createElement(
          ClassificationWrap,
          null,
          classificationTitle &&
            /*#__PURE__*/ React.createElement(
              'div',
              {
                style: {
                  marginBottom: 8,
                },
              },
              classificationTitle,
            ),
          /*#__PURE__*/ React.createElement(
            'div',
            {
              style: {
                flex: 1,
              },
            },
            /*#__PURE__*/ React.createElement(
              TreeMenu,
              _objectSpread(
                _objectSpread({}, classificationWithTitle),
                {},
                {
                  getPopupContainer: function getPopupContainer(triggerNode) {
                    return pageInstance.current || document.body;
                  },
                },
              ),
            ),
          ),
        ),
      /*#__PURE__*/ React.createElement(
        'div',
        {
          style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          },
        },
        /*#__PURE__*/ React.createElement(
          Toolbar,
          {
            prefixCls: prefixCls,
            visible: Boolean(buttonsCount) || Boolean(showFullscreen),
          },
          /*#__PURE__*/ React.createElement(
            Space,
            {
              style: {
                flex: 1,
              },
            },
            Boolean(rowSelectionCount) &&
              /*#__PURE__*/ React.createElement(
                React.Fragment,
                null,
                /*#__PURE__*/ React.createElement(
                  RowSelectionInfo,
                  null,
                  contextLocale.lang.chosen,
                  ' ',
                  /*#__PURE__*/ React.createElement('span', null, rowSelectionCount),
                  ' \u6761',
                ),
                /*#__PURE__*/ React.createElement(
                  Button,
                  {
                    type: 'link',
                    size: 'small',
                    onClick: function onClick() {
                      var _tableInstance$curren;
                      return (_tableInstance$curren = tableInstance.current) === null ||
                        _tableInstance$curren === void 0
                        ? void 0
                        : _tableInstance$curren.resetToEmpty();
                    },
                  },
                  contextLocale.lang.cancel,
                ),
              ),
          ),
          /*#__PURE__*/ React.createElement(
            Space,
            null,
            showFullscreen &&
              /*#__PURE__*/ React.createElement(Button, {
                icon: /*#__PURE__*/ React.createElement(Icon, {
                  type: isFullscreen ? 'FullscreenExitOutlined' : 'FullscreenOutlined',
                  antdIcon: true,
                }),
                tooltip: isFullscreen ? '退出全屏' : '全屏',
                onClick: function onClick() {
                  return (
                    pageInstance.current &&
                    screenfull.isEnabled &&
                    (isFullscreen ? screenfull.exit() : screenfull.request(pageInstance.current))
                  );
                },
              }),
            batchedActions &&
              /*#__PURE__*/ React.createElement(
                BatchedActions,
                {
                  menu: batchedActions,
                  // getPopupContainer={(triggerNode: any) => pageInstance.current || document.body}
                  disabled: !rowSelectionCount,
                },
                /*#__PURE__*/ React.createElement(
                  Button,
                  {
                    disabled: !rowSelectionCount,
                  },
                  contextLocale.lang.bulkOperations,
                  /*#__PURE__*/ React.createElement(ArrowDownSOutlined, {
                    style: {
                      marginLeft: 4,
                    },
                  }),
                ),
              ),
            importBtn &&
              /*#__PURE__*/ React.createElement(
                ExportButton,
                _objectSpread(
                  _objectSpread({}, importBtn),
                  {},
                  {
                    noSecondConfirmation: true,
                    icon: /*#__PURE__*/ React.createElement(ImportOutlined, {
                      style: {
                        marginRight: 4,
                      },
                    }),
                  },
                ),
                contextLocale.lang.import,
              ),
            exportProps &&
              /*#__PURE__*/ React.createElement(ExportButton, _objectSpread({}, exportProps)),
            columnsControl &&
              /*#__PURE__*/ React.createElement(ColumnsControl, _objectSpread({}, columnsControl)),
            toolBarRightButtonsFormatted,
          ),
        ),
        /*#__PURE__*/ React.createElement(
          'div',
          {
            style: {
              flex: 1,
              overflow: 'hidden',
            },
          },
          /*#__PURE__*/ React.createElement(
            MemoTable,
            _objectSpread(
              _objectSpread({}, table),
              {},
              {
                onTableScroll: closeFilter,
                pagination: tablePagination,
                ref: tableInstance,
              },
            ),
          ),
        ),
      ),
    ),
  );
});
export default /*#__PURE__*/ React.memo(StandardizeTable);
